import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation addProcessingUserAccess(
      $username: String!
      $objectType: String!
      $objectValue: String!
      $hasAccess: Boolean!
    ) {
      addProcessingUserAccess(
        username: $username
        objectType: $objectType
        objectValue: $objectValue
        hasAccess: $hasAccess
      ) {
        success
      }
    }
  `,
  mutationName: "addProcessingUserAccess",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/access/addUserAccess.js